<template>
    <div class="gameloader"></div>
</template>


<script>
const iframeClass = 'gameloader--iframe',
  gameLoaderClass = 'gameloader';

import store from '../store';
import ListGames from './ListGames.vue';
import { games } from '../games';

export default {
  name: 'run',
  watch: {
    '$route.params.game_id': function (id) {
      this._loadGame();
    }
  },
  components: {
    'list-games': ListGames
  },
  computed: {
    title() {
      return this._getGameData().title;
    }
  },
  data () {
    return { }
  },
  methods: {
    _send(id, payload) {
      const iframe = document.querySelector(`.${iframeClass}`);
      iframe.contentWindow.postMessage({id, payload}, document.location.origin);
    },
    _loadGame() {
      return new Promise((resolve, reject) => {
        try {
          const iframe = document.createElement('iframe');
          iframe.onload = event => {
            resolve(event.target);
          };
          iframe.onerror = event => {
            reject(event);
          };
          iframe.className = iframeClass;
          iframe.src = 'games/' + this.$route.params.game_id + '/index.html';
          document.querySelector(`.${gameLoaderClass}`).innerHTML = '';
          document.querySelector(`.${gameLoaderClass}`).appendChild(iframe);
        } catch (error) {
          reject(error);
        }
      });
    },
    _onMessage(event) {
      const id = event.data.id;
      const payload = event.data.payload;
      console.log(id, payload);
      switch (id) {
      case 'state:get':
        this._send(
          'state:get',
          {}
        );
        break;
      case 'state:set':
        break;
      case 'init':
        const init = {
          'assetsPath': '../../assets/',
          'locale': this.$route.params.lang
        };
        this._send('init', init);
        break;
      case 'track':
        break;
      case 'handshake':
          this._send('handshake');
          break;
      }
    },
    _bindPostMessage() {
      return new Promise((resolve, reject) => {
        try {
          window.addEventListener('message', this._onMessage);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    _getGameData() {
      for (let i = 0; i < games.length; i++) {
        if (games[i].name === this.$route.params.game_id) {
          return games[i];
        }
      }
    }
  },
  mounted: function() {
    console.log('mounted');
    this._loadGame().then( this._bindPostMessage );
  },
  beforeDestroy() {
    removeEventListener('message', this._onMessage);
  },
  created: function() {
    console.log('Play component created');
  }
}

</script>

<style scope>
html, body, #app, .gameloader {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}
.gameloader--iframe {
  margin: 0;
  border: none;
  background-color: #a6a6a6;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// Run.vue?fa31269e